import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ReportBaseService } from './report-base.service';

import { UtilsService } from './utils.service';
import { Notifications_DatasourceService } from './Notifications.datasource.index';

interface INotifications_log_notes_reportServiceInParams {
  transaction_id: string, log_ids?: string[], message_ids?: string[]}

interface INotifications_log_notes_reportServiceData {
  transaction_report?: { result?: { transaction_id?: string, ingress_id?: string, egress_id?: string, integration_name?: string, status?: string, direction?: string, reference?: string, sender?: string, receiver?: string, payload?: string, transaction_type?: string, environment?: string, process?: string, level?: number, created_on?: string, created_by?: string, log_notes?: string, message_notes?: string, log_details?: { field?: string, content?: string }[], message_details?: { field?: string, content?: string }[] } }
}

@Injectable({ providedIn: 'root' })
export class Notifications_log_notes_reportService extends ReportBaseService<INotifications_log_notes_reportServiceInParams, INotifications_log_notes_reportServiceData> {

  protected reportReferenceName = 'log_notes_report';
  protected appReferenceName = 'Notifications';

  constructor(
    $utils: UtilsService,
    private $datasources: Notifications_DatasourceService,
    ) {
      super($utils);
  }

  override throwIfMissingRequiredInParams ($inParams: INotifications_log_notes_reportServiceInParams) {
  }

  protected async getData($inParams: INotifications_log_notes_reportServiceInParams): Promise<INotifications_log_notes_reportServiceData> 
  {
    const $utils = this.$utils;
    const $report: { inParams: INotifications_log_notes_reportServiceInParams } = {
      inParams: $inParams
    };

    const $data: INotifications_log_notes_reportServiceData = {
    };
    const $datasourcesQueries: (() => Promise<void>)[] = [];

    $datasourcesQueries.push(async () => {
      const $dsParams = {
        transaction_id:  $report.inParams.transaction_id ,
        log_ids:  $report.inParams.log_ids ,
        message_ids:  $report.inParams.message_ids 
      };
      
      const dsData = await this.$datasources.Notifications.ds_transaction_report.get($dsParams);
      
      $data.transaction_report = dsData;
    });

    await Promise.all($datasourcesQueries.map(t => t()));

    return $data;
  }
}
